import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { C } from './UI';

const LANGUAGES = [
  { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
  { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'it', label: 'IT', flag: '🇮🇹', name: 'Italiano' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  function select(code) {
    i18n.changeLanguage(code);
    localStorage.setItem('ebios_language', code);
    setOpen(false);
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '7px 12px', borderRadius: 8,
          border: `1px solid ${C.border}`,
          background: C.surface2, color: C.text2,
          cursor: 'pointer', fontSize: 13, fontWeight: 600,
          transition: 'all 0.15s',
        }}
      >
        <span>{current.flag}</span>
        <span>{current.label}</span>
        <span style={{ fontSize: 10, opacity: 0.6 }}>{open ? '▲' : '▼'}</span>
      </button>

      {open && (
        <>
          {/* Overlay pour fermer au clic extérieur */}
          <div style={{ position: 'fixed', inset: 0, zIndex: 998 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: '100%', right: 0, marginTop: 6,
            background: C.surface, border: `1px solid ${C.border}`,
            borderRadius: 10, padding: 6, zIndex: 999, minWidth: 160,
            boxShadow: `0 8px 24px rgba(0,0,0,0.3)`,
          }}>
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => select(lang.code)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  width: '100%', padding: '8px 12px', borderRadius: 7,
                  border: 'none', background: lang.code === i18n.language ? 'rgba(79,124,255,.1)' : 'transparent',
                  color: lang.code === i18n.language ? C.accent : C.text2,
                  cursor: 'pointer', fontSize: 13, fontWeight: lang.code === i18n.language ? 600 : 400,
                  textAlign: 'left', transition: 'background 0.1s',
                }}
              >
                <span style={{ fontSize: 18 }}>{lang.flag}</span>
                <span>{lang.name}</span>
                {lang.code === i18n.language && <span style={{ marginLeft: 'auto', fontSize: 11 }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
